// @ts-nocheck
/* eslint-disable */

import React from 'react';
import EntityTable from 'app/components/CRUD/EntityTable';
import StyleIcon from '@mui/icons-material/Style';
import moment from 'moment';
import { useIntl } from 'react-intl';

import {
  CONFIG_ROUTES,
  CONFIG_URLS,
} from 'app/configuration/configuration-api';

const FareMediaTypesTable: React.FC = () => {
  const intl = useIntl();

  const yesNo = value =>
    value ? intl.formatMessage({ id: 'Yes' }) : intl.formatMessage({ id: 'No' });

  /**
   * Closed Yes/No option set. `name` carries the translated label because
   * FilterEntity falls back to option.name when no optionConfig.labelField is
   * given, and `value` matches the API's is_test / is_old query params.
   */
  const yesNoOptions = [
    { value: 'true', name: intl.formatMessage({ id: 'Yes' }) },
    { value: 'false', name: intl.formatMessage({ id: 'No' }) },
  ];

  return (
    <EntityTable
      // ============ PAGE CONFIGURATION ============
      pageTitle="FareMediaTypes"
      pageIcon={StyleIcon}
      addButtonLabel="AddNewFareMediaType"

      // ============ NAVIGATION URLs ============
      addPageUrl={`${CONFIG_ROUTES.fareMediaTypes}/new`}
      viewPageUrl={`${CONFIG_ROUTES.fareMediaTypes}/:id`}
      editPageUrl={`${CONFIG_ROUTES.fareMediaTypes}/:id/edit?came_from=all`}

      // ============ API CONFIGURATION ============
      getApiUrl={CONFIG_URLS.fareMediaTypes}
      getApiMethod="GET"

      // Hard DELETE — no soft-delete column. The API refuses with a translated
      // 409 when fare_media rows still use the type (ON DELETE RESTRICT), and
      // EntityTable surfaces that message in a toast.
      deleteApiUrl={CONFIG_URLS.fareMediaTypeById}
      deleteApiMethod="DELETE"

      // ============ RESPONSE CONFIGURATION ============
      responseDataPath="data.data.fareMediaTypes"
      responsePaginationPath="data.data.pagination"

      // ============ TABLE CONFIGURATION ============
      idField="id"
      columns={[
        {
          field: 'en_name',
          headerKey: 'NameEnglish',
          align: 'center',
          sortable: true,
          sortField: 'fmt.en_name',
        },
        {
          field: 'ar_name',
          headerKey: 'NameArabic',
          align: 'center',
          sortable: true,
          sortField: 'fmt.ar_name',
        },
        {
          field: 'is_test',
          headerKey: 'IsTest',
          align: 'center',
          render: value => yesNo(value),
          sortable: true,
          sortField: 'fmt.is_test',
        },
        {
          field: 'is_old',
          headerKey: 'IsOld',
          align: 'center',
          render: value => yesNo(value),
          sortable: true,
          sortField: 'fmt.is_old',
        },
        {
          field: 'created_by_username',
          headerKey: 'CreatedBy',
          align: 'center',
          render: value => value || '-',
        },
        {
          field: 'created_at',
          headerKey: 'CreatedAt',
          align: 'center',
          render: value => (value ? moment(value).format('DD/MM/YYYY HH:mm:ss') : '-'),
          sortable: true,
          sortField: 'fmt.created_at',
        },
      ]}

      // ============ SEARCH CONFIGURATION ============
      searchQueryParam="search"
      searchPlaceholder="SearchFareMediaTypePlaceholder"
      searchInputWidth="300px"

      // ============ FILTER CONFIGURATION ============
      filterFields={[
        {
          name: 'is_test',
          labelKey: 'IsTest',
          type: 'dropdown',
          staticOptions: yesNoOptions,
          optionConfig: { valueField: 'value', labelField: 'name' },
        },
        {
          name: 'is_old',
          labelKey: 'IsOld',
          type: 'dropdown',
          staticOptions: yesNoOptions,
          optionConfig: { valueField: 'value', labelField: 'name' },
        },
      ]}

      // ============ PERMISSIONS ============
      subsystemName="FareMediaTypes"
      permissionSystem="masterConfig"

      // ============ ACTIONS ============
      showAddButton={true}
      showActions={true}
      showEdit={true}
      showDelete={true}
      deleteConfirmationMessage="AreYouSureDeleteFareMediaType"
    />
  );
};

export default FareMediaTypesTable;
